import {Box, Typography} from '@mui/material';
import {EntityShift} from '../../../backend/interfaces/entity-shift';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import '../shifts-allocations-input/shift-allocation-select-input.scss';
import {ShiftMembers} from '../shifts-allocations-table/shifts-allocations-table';

interface ShiftAllocationPreviewProps {
  shifts: EntityShift[];
  day: string;
  userId: string;
  edit?: boolean;
  shiftMembers?: ShiftMembers;
}

const ShiftAllocationPreview = ({
  shifts,
  day,
  userId,
  edit = false,
  shiftMembers = undefined,
}: ShiftAllocationPreviewProps) => {
  const {t} = useTranslation();

  const renderContent = () => {
    return (
      <Box className="shifts-container">
        {shifts.map((shift, index) => {
          if (index > 3) return null;

          const plus = shifts.length > 4 && index > 2;
          const label =
            shifts.length === 1 || (shifts.length === 3 && index === 2)
              ? shift.name
              : plus
                ? `+${shifts.length - 3}`
                : shift.abbreviation;
          return (
            <Box
              className="name-container"
              key={shift.id}
              sx={{
                width:
                  shifts.length === 1 || (shifts.length === 3 && index === 2)
                    ? '100%'
                    : 'calc(50% - 1px)',
                height: shifts.length <= 2 ? '100%' : 'calc(50% - 1px)',
                backgroundColor:
                  !shift.backgroundColor || plus
                    ? 'var(--dcm-white-darker)'
                    : shift.backgroundColor,
              }}
            >
              <Typography
                className="name"
                style={{
                  color: plus ? 'var(--dcm-blue-base)' : shift.foregroundColor,
                  marginTop: shifts.length <= 2 ? '2px' : '0px',
                  marginLeft: plus ? 'auto' : !edit ? '6px' : '8px',
                  textAlign: plus ? 'center' : 'left',
                }}
              >
                {label}
              </Typography>

              {!edit && !plus && (
                <Typography
                  className="members"
                  sx={{
                    color: shift.foregroundColor ?? 'var(--dcm-white-darker)',
                    bottom: shifts.length <= 2 ? '2px' : '0px',
                    right: !edit ? '6px' : '8px',
                  }}
                >
                  {shiftMembers && shiftMembers[shift.id!][day!] && shift.maxShiftMembers
                    ? `${shiftMembers[shift.id!][day!]}/${shift.maxShiftMembers}`
                    : ''}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    );
  };

  if (shifts.length === 0) {
    if (!edit) {
      return <Box className="shift-allocation-empty" />;
    }
    return (
      <Box className="shift-allocation-empty-edit" key={`allocation_${userId}_${day}`}>
        <Typography noWrap>
          {t(translations.office.professional_caregiver.shifts_allocations.table.select_shift)}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={edit ? {cursor: 'pointer'} : undefined}
      className="shift-allocation-preview"
      key={`allocation_${userId}_${day}`}
    >
      {renderContent()}
    </Box>
  );
};

export default ShiftAllocationPreview;
